/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import cogoToast from "cogo-toast";
import { localStorageItems } from "../../../utils/constant";
import { Button, Modal } from 'semantic-ui-react';
import { LOCAL_STORAGE } from '../../utils/constants';


const BillApprovalModal = ({ getApproveBillData, selectedRows, approveBillsSelected, handleCloseBillApproval, ...props }) => {

    const [allRefNo, setAllRefNo] = useState('')
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        const selectedRef = selectedRows.map(({ refNo }) => refNo)
        setAllRefNo(selectedRef.toString().replaceAll(",", ", "))
    }, [selectedRows])

    const handleSubmit = () => {
        setSubmitting(true)
        const selectedRef = selectedRows.map(({ refNo }) => { return { reference_number: refNo } })

        const { customerNo, userId, apiToken } = localStorageItems;
        let loginDts = {
            customerCompanyName: LOCAL_STORAGE.customerCompanyName,
            customerName: LOCAL_STORAGE.customerName,
            customerLogo: LOCAL_STORAGE.customerLogo,
        };
        let data = JSON.stringify
            ({
                "customer_no": customerNo,
                "user_id": userId,
                "invoice_details": selectedRef,
                loginDts: loginDts
            })

        axios.post(`${process.env.REACT_APP_BASE_URL}/sales/sales-invoices/approveInvoice`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': apiToken
            }
        }).then((response => {
            cogoToast.success('Customer Invoice Approved').then(() => {
                window.location.href = '/customerinvoice';
            })
        }))
            .catch(error => cogoToast.error(error.response.data.message).then(() => {
                window.location.href = '/customerinvoice';
            }))
    }

    return (
        <>
            <Modal.Content>
                Are You Sure You Want to Approve This Reference {allRefNo} ?
            </Modal.Content>

            <Modal.Actions>
                <Button onClick={handleCloseBillApproval} size="mini">Cancel</Button>
                <Button disabled={submitting} type="submit" onClick={handleSubmit} size="mini" primary>Yes</Button>
            </Modal.Actions>

        </>
    )
}


export default BillApprovalModal
